import DealerCopyDefaultCategorySection from 'Components/DealerCopy/DealerCopyDefaultCategorySection';
import DealerCopyGroupedCeilingSection from 'Components/DealerCopy/DealerCopyGroupedCeilingSection';
import DealerCopyGroupedMerchandisingToolingSection from 'Components/DealerCopy/DealerCopyGroupedMerchandisingToolingSection';
import DealerCopyGroupedProjectWallSection from 'Components/DealerCopy/DealerCopyGroupedProjectWallSection';
import DealerCopyGroupedToolingSection from 'Components/DealerCopy/DealerCopyGroupedToolingSection';
import { InventoryItemCategoryEnumValue } from 'enums/InventoryItemCategoryEnum';
import React from 'react';

// material-ui

// Icons

// Styles

// Actions

// Components

// Others

export const ProfilePreviousProjectInventoryItemCategoryRow = ({
  category,
  categoryLabel,
  projectInventoryItems,
  totalCol,
  projectWalls,
  projectToolings,
  ceilingId,
  projectCurrency,
  setWarningModalInfo,
}) => {
  switch (category.value) {
    case InventoryItemCategoryEnumValue.MerchandisingTooling:
      return (
        <DealerCopyGroupedMerchandisingToolingSection
          categoryLabel={categoryLabel}
          projectInventoryItems={projectInventoryItems}
          headerColSpan={totalCol}
          projectCurrency={projectCurrency}
          setWarningModalInfo={setWarningModalInfo}
        />
      );
    case InventoryItemCategoryEnumValue.MerchandisingDisplay:
      return (
        <DealerCopyGroupedProjectWallSection
          projectInventoryItems={projectInventoryItems}
          projectWalls={projectWalls}
          headerColSpan={totalCol}
          projectCurrency={projectCurrency}
          setWarningModalInfo={setWarningModalInfo}
        />
      );
    case InventoryItemCategoryEnumValue.CeilingElement:
      return (
        <DealerCopyGroupedCeilingSection
          categoryLabel={categoryLabel}
          projectInventoryItems={projectInventoryItems}
          ceilingId={ceilingId}
          headerColSpan={totalCol}
          projectCurrency={projectCurrency}
          setWarningModalInfo={setWarningModalInfo}
        />
      );
    case InventoryItemCategoryEnumValue.WallMountedSpecialDisplayAndTooling:
      return (
        <DealerCopyGroupedToolingSection
          projectInventoryItems={projectInventoryItems}
          projectToolings={projectToolings}
          headerColSpan={totalCol}
          projectCurrency={projectCurrency}
          setWarningModalInfo={setWarningModalInfo}
        />
      );
    default:
      return (
        <DealerCopyDefaultCategorySection
          categoryLabel={categoryLabel}
          projectInventoryItems={projectInventoryItems}
          headerColSpan={totalCol}
          projectCurrency={projectCurrency}
          setWarningModalInfo={setWarningModalInfo}
        />
      );
  }
};

export default ProfilePreviousProjectInventoryItemCategoryRow;
